import dayjs, { PluginFunc } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
export { Dayjs } from 'dayjs';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(quarterOfYear);
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);
dayjs.extend(advancedFormat);
dayjs.extend(updateLocale);
dayjs.extend(weekOfYear);
dayjs.extend(duration);
dayjs.updateLocale('en', {
  // use Monday as start of week
  weekStart: 1,
});

/*
 * The timezone support in dayjs is not great and contains various bugs.
 * See: https://github.com/iamkun/dayjs/issues?q=timezone
 *
 * We don't really make complex use of the timezone functionality, merely
 * wanting to convert stuff to the current tenant's timezone
 * to user's timezone & vice-versa, so this doesn't seem like
 * a good reason to write off an otherwise good library.
 *
 * The main issue that affects us relates to the incorrect calculation of UTC
 * offsets when dealing with daylight savings time. There is a PR to fix this
 * open in the dayjs repo, which will hopefully be merged soon:
 * https://github.com/iamkun/dayjs/pull/1448
 *
 * Until then, we can replicate the work of that PR by writing an additional
 * plugin which overrides the existing UTC valueOf function with the fixed version
 * from https://github.com/iamkun/dayjs/pull/1448/files#diff-2612403b0bf524678efca9da730f3570b7a058b447238e00dd98d7f3d890abeeR116-R118
 */

const utcFix: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.valueOf = function () {
    // @ts-ignore
    const addedOffset = !this.$utils().u(this.$offset)
      ? // @ts-ignore
        this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset())
      : 0;
    // @ts-ignore
    return this.$d.valueOf() - addedOffset * 60 * 1000;
  };
};
dayjs.extend(utcFix);
export const dayjsTz = dayjs;

export const DATE_FORMAT = 'MMM DD, YYYY';
export const DATE_FORMAT_WITH_TIME = 'MMM DD, YYYY h a';

export const dateObjFromUnixWithTZ = (timestamp?: number) =>
  timestamp ? dayjs(timestamp * 1000).tz() : undefined;
